import api from "@/services/api.service";
import { ActionTree } from "vuex";
import { ActivityLogDTO, ActivityLogPagedResponse, ActivityLogReportRequest, ActivityLogState } from "./types";
import { RootState } from "../types";
import { PaginatedSearchRequest } from "@/mixins/PaginatedSearch";

export const actions: ActionTree<ActivityLogState, RootState> = {
	async getActivityLog({ commit }, request: PaginatedSearchRequest) : Promise<ActivityLogPagedResponse>  {
		return await api.getActivityLog(request);
	},
	async addActivityLog({ commit }, newLog: ActivityLogDTO) {
		return await api.addActivityLog(newLog);
	},
	async editActivityLog({ commit }, activityLog: ActivityLogDTO) {
		return await api.editActivityLog(activityLog);
	},
	async hideActivityLog({ commit }, activityLogId: number) {
		return await api.hideActivityLog(activityLogId);
	},
	async unHideActivityLog({ commit }, activityLogId: number) {
		return await api.unHideActivityLog(activityLogId);
	},
	async getActivityLogOutcomes({ commit }, areaId: null | boolean) {
		return await api.getActivityLogOutcomes(areaId ? areaId : null);
	},
	async getActivityLogEntry({ commit }, activityLogId: number): Promise<ActivityLogDTO> {
		return await api.getActivityLogEntry(activityLogId);
	},
	async getActivityLogsAsCsv({ commit }, request: ActivityLogReportRequest): Promise<any> {
		return await api.getActivityLogsAsCsv(request);
	},
};
